import React, { useEffect, useRef, useState } from 'react';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';

/**
 * Un «?» con dos líneas de explicación, solo donde hay un concepto que no se
 * entiende mirando la pantalla (docs/onboarding-ar-plan.md). Se abre al pulsar
 * y se cierra al pulsar fuera o con Escape: no tapa nada mientras no se pide.
 */
const HelpTip = ({ title, children, className = '' }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const fuera = e => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    const escape = e => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', fuera);
    document.addEventListener('keydown', escape);
    return () => {
      document.removeEventListener('mousedown', fuera);
      document.removeEventListener('keydown', escape);
    };
  }, [open]);

  return (
    <span ref={ref} className={`relative inline-flex align-middle ${className}`}>
      <button
        type='button'
        onClick={() => setOpen(o => !o)}
        className='text-slate-400 hover:text-slate-600'
        aria-label={`Ayuda: ${title}`}
        aria-expanded={open}
      >
        <QuestionMarkCircleIcon className='h-4 w-4' />
      </button>
      {open && (
        <span
          role='tooltip'
          className='absolute left-0 top-6 z-30 w-72 rounded-lg border border-slate-200 bg-white p-3 text-left text-xs font-normal text-slate-700 shadow-lg'
        >
          <span className='mb-1 block font-semibold text-slate-800'>{title}</span>
          {children}
        </span>
      )}
    </span>
  );
};

export default HelpTip;
